var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6041 8.43764L17.7873 24.252C16.2122 25.8268 11.5368 26.5562 10.4923 25.5119C9.44774 24.4675 10.1607 19.7928 11.7357 18.218L27.5692 2.38698C27.9596 1.96105 28.4323 1.61867 28.9589 1.38046C29.4853 1.14225 30.0546 1.01311 30.6324 1.00095C31.21 0.988795 31.7844 1.09379 32.3204 1.30964C32.8564 1.52549 33.3432 1.84775 33.7512 2.25687C34.1592 2.66599 34.4802 3.15352 34.6946 3.69005C34.9089 4.2266 35.0125 4.80099 34.9988 5.37862C34.985 5.95625 34.8542 6.52515 34.6146 7.05089C34.3749 7.57663 34.0312 8.0484 33.6041 8.43764Z",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4H7.88889C6.06183 4 4.30973 4.72578 3.01781 6.0177C1.7259 7.30963 1 9.06183 1 10.8889V28.1111C1 29.9382 1.7259 31.6904 3.01781 32.9822C4.30973 34.2743 6.06183 35 7.88889 35H26.8333C30.6394 35 32 31.9 32 28.1111V19.5",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.f8f7e50cf1583b012b4532f03bdbf8b4.svg";
export { ForwardRef as ReactComponent };